<template>
  <statistic-card-with-area-chart
    v-if="loaded"
    icon="KeyIcon"
    :statistic="'$'+dFormatter(refTVL)"
    color="success"
    statistic-title="Total Value Locked"
    :chart-data="series"
  />
</template>

<script>
import StatisticCardWithAreaChart from '@core/components/statistics-cards/StatisticCardWithAreaChart.vue'
import { dFormatter } from '@core/utils/filter'
import axios from 'axios'

export default {
  components: {
    StatisticCardWithAreaChart,
  },
  data() {
    return {
      loaded: false,
      refTVL: 0,
      series: [
        {
          data: []
        }
      ]
    }
  },
  methods: {
    dFormatter,
  },
  mounted () {
    this.loaded = false
    const endpoint = `https://api.llama.fi/protocol/meta-pool`
    axios.get(endpoint)
    .then(response => {
      this.refTVL = response.data["tvl"][response.data["tvl"].length - 1].totalLiquidityUSD
      
      for (let index = response.data["tvl"].length - 45; index < response.data["tvl"].length; index++) {
        this.series[0].data.push({
          x: new Date(response.data["tvl"][index].date),
          y: response.data["tvl"][index].totalLiquidityUSD
        })
      }
      this.loaded = true;
    })
    .catch(e => {
      console.error(e)
    })
  }
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-flatpicker.scss';
@import '@core/scss/vue/libs/chart-apex.scss';
</style>
